import React from 'react'
import { CareTeamCarousel } from './CareTeamCarousel'
import { CareTeamGrid } from './CareTeamGrid'
import './care-team.css'

type CareTeamProps = {
  _type: 'careTeam'
  title?: string
  subtitle?: string
  deepLinkId?: string
  options?: {
    uid?: string
  }
  providers?: any
  viewType?: 'grid' | 'carousel'
  backgroundColor?:
    | 'bcorange'
    | 'bcb'
    | 'bcw'
    | 'bcblue'
    | 'bcp'
    | 'bcbluetint'
    | 'bcotint'
    | 'bcgtint'
    | 'bcptint'
    | 'bcraspberry'
    | 'bcpoppy'
    | 'bcoat'
    | 'bccream'
    | 'bctran'
  visibleCount?: number
  mobileVisibleCount?: number
  showSpecialtyFilter?: boolean
  showProviderTypeFilter?: boolean
  showLocationFilter?: boolean
  itemsPerRow?: number
  mobileItemsPerRow?: 1 | 2
  spacing?: 'pyxs' | 'pys' | 'pym' | 'pyl'
}

const CareTeam: React.FC<{ data: CareTeamProps }> = ({ data }) => {
  const { viewType } = data

  return viewType === 'grid' ? (
    <CareTeamGrid data={data} />
  ) : (
    <CareTeamCarousel data={data} />
  )
}

export { CareTeam }
export type { CareTeamProps }
